module.exports = __webpack_public_path__ + "static/img/tab-ten-active.91893402.png";